import React from 'react';
import { Text, View, Link } from '@react-pdf/renderer';
import { StyleSheet } from '@react-pdf/renderer';
import { cvStyles } from '../cvStyles';
import { cvConfig } from '../cvConfig';

// Estilos específicos para certificaciones
const certStyles = StyleSheet.create({
  certGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  certItem: {
    width: '48%',
    marginBottom: 12,
    padding: 10,
    backgroundColor: cvConfig.colors.sectionBg,
    borderRadius: 3,
    borderLeft: `3 solid ${cvConfig.colors.accent}`,
  },
  certHeader: {
    marginBottom: 6,
  },
  certTitle: {
    fontSize: cvConfig.fonts.size.body,
    fontFamily: cvConfig.fonts.bold,
    color: cvConfig.colors.text,
    lineHeight: 1.3,
    marginBottom: 4,
  },
  certDate: {
    fontSize: cvConfig.fonts.size.small,
    color: cvConfig.colors.textLight,
  },
  certIssuer: {
    fontSize: cvConfig.fonts.size.body - 1,
    color: cvConfig.colors.primary,
    fontFamily: cvConfig.fonts.bold,
    marginBottom: 6,
  },
  certFooter: {
    gap: 4,
  },
  certExpiry: {
    fontSize: cvConfig.fonts.size.small - 1,
    color: cvConfig.colors.textLight,
    marginBottom: 3,
  },
  certLink: {
    fontSize: cvConfig.fonts.size.small - 1,
    color: cvConfig.colors.accent,
    textDecoration: 'none',
  },
});

/**
 * Componente para la sección de Certificaciones del CV
 * Muestra todas las certificaciones en formato de dos columnas
 */
export const CVCertifications = ({ certifications }) => {
  if (!certifications || certifications.length === 0) {
    return null;
  }

  // Formatear fecha a formato más corto para el CV
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const month = date.toLocaleDateString('es-ES', { month: 'short' });
    const year = date.getFullYear();
    return `${month}. ${year}`;
  };

  return (
    <View style={cvStyles.section}>
      {/* Título de la sección */}
      <Text style={cvStyles.sectionTitle}>CERTIFICACIONES</Text>

      {/* Grid de certificaciones - 2 columnas */}
      <View style={certStyles.certGrid}>
        {certifications.map((cert, index) => (
          <View 
            key={index} 
            style={certStyles.certItem}
            wrap={false}
          >
            {/* Header: Título y fecha */}
            <View style={certStyles.certHeader}>
              <Text style={certStyles.certTitle}>{cert.title}</Text>
              <Text style={certStyles.certDate}>{formatDate(cert.issue_date)}</Text>
            </View>

            {/* Emisor */}
            <Text style={certStyles.certIssuer}>{cert.issuer}</Text>

            {/* Footer: expiración y/o enlace */}
            <View style={certStyles.certFooter}>
              {cert.expiry_date && (
                <Text style={certStyles.certExpiry}>
                  Válida hasta {formatDate(cert.expiry_date)}
                </Text>
              )}
              
              {cert.credential_url && (
                <Link src={cert.credential_url} style={certStyles.certLink}>
                  Ver credencial
                </Link>
              )}
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};
